var render = function (_h,_vm) {var _c=_vm._c;return _c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.props.value},on:{"change":function($event){return _vm.listeners.input($event.target.checked)}}}),_c('span',{staticClass:"toggle"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }